export enum AppRoutes {
  ROOT = '',
  AUTH = 'auth',
  TODAY = 'today',
  DRILLS = 'drills',
  PROGRESS = 'progress',
  PLAN = 'plan',
  SESSION = 'session',
  PLAYGROUND = 'playground',
  LEGAL = 'legal',
  PROFILE = 'profile',
  PARTNERS = 'partners',
  ADMIN = 'admin',
  AMMO = 'ammo',
  LANG = 'lang',
  BLOCKED_VERSION = 'blocked-version'
}
